<ng-template #notificationFooterLink>
  <a class="url-text text-decoration" routerLink="/core/notifications">{{notificationFooterText}}</a>
</ng-template>

<atom-widget-container
  [widgetState]="notificationState"
  [headerText]="notificationHeaderText">
  <!-- !TODO: reenable when we implement notifications -->
  <!--[footerTemplate]="notificationFooterLink"-->
<div class="body-alert-container">
  <div class="relative w-4rem h-4rem">
    <svg class="body-alert-outer-badge" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"
         fill="none">
      <circle opacity="0.3" cx="32" cy="32" r="32"
              [ngClass]="{
                  'badge-good': notificationState == WidgetState.Good,
                  'badge-info': notificationState == WidgetState.Info
          }"/>
      <circle cx="32" cy="32" r="24"
              [ngClass]="{
                  'badge-good': notificationState == WidgetState.Good,
                  'badge-info': notificationState == WidgetState.Info
          }"/>

    </svg>
    <svg class="body-alert-inner-badge" *ngIf=" notificationState == WidgetState.Good" xmlns="http://www.w3.org/2000/svg" width="24"
         height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_2192_1013" style="mask-type:alpha"
            maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_2192_1013)">
        <path
          d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z"
          fill="#067647"/>
      </g>
    </svg>
  </div>
</div>
<div class="body-text-outer-container">
  <div class="body-text-content-container">
    <div class="body-text-inner-container">
            <span class="body-text-content">
              {{bodyText}}
            </span>
    </div>
  </div>
</div>
</atom-widget-container>
